import _ from 'underscore';
import $ from 'jquery';

export default class OfferCampaignRecipients {
  constructor($scope, $rootScope, OfferCampaignService, UserService) {
    $scope.tabs = [
      {
        title: 'General',
        buyers: []
      },
      {
        title: 'Special',
        buyers: []
      },
      {
        title: 'Restricted',
        buyers: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.check_items = function(tab_index) {
      _.each($scope.get_buyers($scope.tabs[tab_index]), function(buyer) {
        buyer.checked = $scope.tabs[tab_index].checked;
      });
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };
    
    $scope.select2_options_447 = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };

    $scope.add_product_spec = function() {
      $scope.filter.product_specs.push({
        product_category_id: null,
        product_group_id: null,
        product_id: null
      });
    };

    $scope.remove_product_spec = function(spec) {
      $scope.filter.product_specs.splice(_.indexOf($scope.filter.product_specs, spec), 1);
    };

    $scope.search = function() {
      $scope.searching = true;
      $scope.filter.min_quality_accuracy = $scope.filter.pre_min_quality_accuracy;
      $scope.filter.min_specs_accuracy = $scope.filter.pre_min_specs_accuracy;
      $scope.filter.excluded_user_groups = _.pluck(_.where($scope.excluded_groups, {
        checked: true
      }), 'id');
      $scope.filter.product_end_uses = _.pluck(_.where($scope.product_end_uses, {
        checked: true
      }), 'id');
      OfferCampaignService.find_recipients($scope.offer_campaign.id, $scope.filter).success(function(data) {
        $scope.tabs[0].buyers = data.recipients.general;
        $scope.tabs[1].buyers = data.recipients.special;
        $scope.searching = false;
      });
    };

    $scope.add_recipients = function() {
      var general_buyers = _.where($scope.tabs[0].buyers, {
        checked: true
      });
      var special_buyers = _.where($scope.tabs[1].buyers, {
        checked: true
      });
      if (!$scope.adding && (general_buyers.length > 0 || special_buyers.length > 0)) {
        $scope.adding = true;
        $scope.recipients_added = false;
        OfferCampaignService.add_recipients(window.offer_campaign.id, general_buyers, special_buyers).success(function(data) {
          if (data.success) {
            $scope.tabs[0].buyers = _.difference($scope.tabs[0].buyers, general_buyers);
            $scope.tabs[1].buyers = _.difference($scope.tabs[1].buyers, special_buyers);
            $scope.tabs[0].checked = false;
            $scope.tabs[1].checked = false;
            $scope.adding = false;
            $scope.recipients_added = true;
          }
        });
      }
    };

    $scope.automate_recipients = function() {
      var general_buyers = _.where($scope.tabs[0].buyers, {
        checked: true
      });
      var special_buyers = _.where($scope.tabs[1].buyers, {
        checked: true
      });
      if (general_buyers.length > 0 || special_buyers.length > 0) {
        var data = {
          offer_campaign_id: window.offer_campaign.id,
          general_buyers: general_buyers,
          special_buyers: special_buyers,
          min_quantity: $scope.min_quantity
        };
        $rootScope.$broadcast('show_recipients_dialog', data);
      }
    };

    $scope.$on('remove_automated_recipients', function(event, data) {
      $scope.tabs[0].buyers = _.difference($scope.tabs[0].buyers, data.general_buyers);
      $scope.tabs[1].buyers = _.difference($scope.tabs[1].buyers, data.special_buyers);
      $scope.tabs[0].checked = false;
      $scope.tabs[1].checked = false;
    });

    $scope.percentages = [
      {
        value: 0,
        title: '0%'
      },
      {
        value: 1,
        title: '1%'
      },
      {
        value: 20,
        title: '20%'
      },
      {
        value: 40,
        title: '40%'
      },
      {
        value: 60,
        title: '60%'
      },
      {
        value: 80,
        title: '80%'
      },
      {
        value: 100,
        title: '100%'
      }
    ];
    
    $scope.operators = [
      {
        value: 1,
        title: '+'
      },
      {
        value: 2,
        title: '+/-'
      }
    ];
    
    $scope.specs = [
      {
        value: 0,
        title: 'ALL'
      },
      {
        value: 1,
        title: 'Only Yes'
      },
      {
        value: 2,
        title: 'Unknown or Yes'
      }
    ];
    
    $scope.cuts = [
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      },
      {
        value: 3,
        title: '3'
      },
    ];
    
    $scope.wastes = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      }
    ];
    
    $scope.ranges = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '+-0.5'
      },
      {
        value: 2,
        title: '+-1'
      }
    ];

    $scope.specs_status_options = [
      {
        id: 0,
        title: 'All'
      },
      {
        id: 1,
        title: 'Reels'
      },
      {
        id: 2,
        title: 'Sheets'
      }
    ];

    $scope.get_buyers = function(tab) {
      var buyers = tab.buyers;

      if (tab.title === 'Restricted') {
        return buyers;
      }

      if ($scope.attention_filter > 0) {
        var needs_attention = $scope.attention_filter === 1;
        buyers = _.where(buyers, {
          needs_attention: needs_attention
        });
      }

      if ($scope.special_handling_filter > 0) {
        var special_handling = $scope.special_handling_filter === 1;
        buyers = _.where(buyers, {
          special_handling: special_handling
        });
      }
      
      if ($scope.epr_marketing_campaigns_filter > 0) {
        if ($scope.epr_marketing_campaigns_filter === 1) {
          buyers = _.filter(buyers, function(x) {
            return x.epr_marketing_campaigns && x.epr_marketing_campaigns.includes('Yes');
          });
        } else {
          buyers = _.filter(buyers, function(x) {
            return x.epr_marketing_campaigns && x.epr_marketing_campaigns.includes('No');
          });
        }
      }

      return buyers;
    };

    $scope.uncheck_items = function() {
      _.each($scope.tabs, function(tab) {
        tab.checked = false;
        _.each(tab.buyers, function(buyer) {
          buyer.checked = false;
        });
      });
    };

    $scope.attention_filter_options = [
      {
        id: 0,
        title: 'All'
      },
      {
        id: 1,
        title: 'Yes'
      },
      {
        id: 2,
        title: 'No'
      }
    ];

    $scope.get_campaign_criteria = function(offer_campaign_criteria) {
      var status = _.findWhere(window.offer_campaign_criteria_statuses, {
        id: offer_campaign_criteria
      });
      return status.title;
    };

    $scope.quick_search = function(tab_index) {
      window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
    };

    function set_buyer_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          if (!_.findWhere($scope.filter.buyers, {id: ui.item.id})) {
            $scope.filter.buyers.push({
              id: ui.item.id,
              title: ui.item.value
            });
          }
          $scope.buyer_company = null;
          $scope.$apply();
          return false;
        }
      });
    }

    $scope.remove_buyer = function(buyer_id) {
      $scope.filter.buyers = _.reject($scope.filter.buyers, function(buyer) {
        return buyer.id == buyer_id;
      });
    };

    $scope.quick_search_end_uses = function() {
      if ($scope.quick_filter) {
        var regex = new RegExp($scope.quick_filter, 'i');
        _.each($scope.product_end_uses, function(end_use) {
          end_use.visible = end_use.title.search(regex) > -1;
        });

        $scope.search_filter = {
          visible: true
        };
      } else {
        $scope.search_filter = {};
      }
    };
    
    
    $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
      if (check_eu_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.eu_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.eu_countries);
      }
      $('#buyer_countries').select2('val', $scope.filter.user_countries);
    };
    
    $scope.toggleAsiacountries = function toggleAsiacountries(check_asia_countries) {
      if (check_asia_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.asia_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.asia_countries);
      }
      $('#buyer_countries').select2('val', $scope.filter.user_countries);
    };
    
    $scope.toggleAfricacountries = function toggleAfricacountries(check_africa_countries) {
      if (check_africa_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.africa_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.africa_countries);
      }
      $('#buyer_countries').select2('val', $scope.filter.user_countries);
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.offer_campaign = window.offer_campaign;
      $scope.filter = OfferCampaignService.get_default_filter();
      if (window.offer_campaign.search_criteria) {
        $scope.filter = window.offer_campaign.search_criteria;
        if (!$scope.filter.product_specs)
          $scope.filter.product_specs = [];
        if (!$scope.filter.excluded_user_countries)
          $scope.filter.excluded_user_countries = [];
        if (!$scope.filter.specs_status)
          $scope.filter.specs_status = 0;
        if (!$scope.filter.excluded_user_groups)
          $scope.filter.excluded_user_groups = [];
        if (!$scope.filter.buyers) {
          $scope.filter.buyers = [];
        }
        if (!$scope.filter.product_end_uses) {
          $scope.filter.product_end_uses = [];
        }
      }
      $scope.excluded_groups = OfferCampaignService.get_groups();
      OfferCampaignService.update_excluded_groups($scope.excluded_groups, $scope.filter);
      $scope.current_page = 'recipients_find';
      $scope.product_categories = window.product_categories;
      if ($scope.filter.product_specs.length === 0)
        $scope.add_product_spec();
      $scope.attention_filter = 0;
      $scope.special_handling_filter = 0;
      $scope.epr_marketing_campaigns_filter = 0;
      $scope.tabs[2].buyers = window.restricted_buyers;
      $scope.min_quantity = 0;
      $scope.offer_id = window.offer_campaign.offer_id;
      $scope.show_all_product_end_uses = false;
      $scope.show_suggested_product_end_uses = false;
      $scope.eu_countries = window.eu.countries.map(a => String(a.id));
      $scope.asia_countries = window.asia.countries.map(a => String(a.id));
      $scope.africa_countries = window.africa.countries.map(a => String(a.id));
      if (_.difference($scope.eu_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_eu_countries = true;
      }
      if (_.difference($scope.asia_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_asia_countries = true;
      }
      if (_.difference($scope.africa_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_africa_countries = true;
      }
      set_buyer_company_autocomplete($('input.buyer_company'));
      $scope.product_end_uses = window.product_end_uses;
      _.each($scope.filter.product_end_uses, function(end_use) {
        var product_end_use = _.findWhere($scope.product_end_uses, {
          id: end_use
        });
        if (product_end_use) {
          product_end_use.checked = true;
        }
      });
      _.each(window.suggested_product_end_uses, function(end_use) {
        var product_end_use = _.findWhere($scope.product_end_uses, {
          id: end_use.id
        });
        if (product_end_use) {
          product_end_use.suggested = true;
        }
      });
    };

    $scope.init();
  }
}

OfferCampaignRecipients.$inject = ['$scope', '$rootScope', 'OfferCampaignService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-recipients.ctrl.js